export const saloonImageOptions = {
  legacy: true,
  prefix: 'X4_9_Interior',
  angle: 'saloon',
  staticOptions: {
    BeautyBox: 1,
    CupboardsOwnersCabin: 1,
    SplitBerth: 1,
    CupboardsAftCabin: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X49/views/saloon.js